import { HttpStatusCode } from 'data/protocols/http';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { DeleteInternshipLocationUseCaseInterface } from 'domain/usecases';

export class RemoteDeleteInternshipLocation
  implements DeleteInternshipLocationUseCaseInterface
{
  constructor(
    private readonly url: string,
    private readonly httpClient,
  ) {}

  async execute(
    params: DeleteInternshipLocationUseCaseInterface.Params,
  ): Promise<DeleteInternshipLocationUseCaseInterface.Result> {
    const requestUrl = `${this.url}/${params.id}`;

    const httpResponse = await this.httpClient.request({
      url: requestUrl,
      method: 'delete',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body.message);
    }
  }
}
